import { WeightUnit } from '~/constants/weight';

const formatCurrency = (
  a: { currency_iso: string; minimumFractionDigits?: number; value: number },
  locale: string,
): string => {
  if (a?.value === undefined || a.value === null) return '';

  if (!a.currency_iso) return a.value.toString();

  const formatter = new Intl.NumberFormat(locale, {
    currency: a.currency_iso,
    minimumFractionDigits: a.minimumFractionDigits === undefined ? 2 : a.minimumFractionDigits,
    style: 'currency',
  });

  return formatter.format(a.value);
};

const formatNumber = (a: { value: number } | number, lng: string): string => {
  let value: number;
  if (typeof a === 'number') value = a;
  else if (a?.value === undefined || a?.value === null) return '';
  else value = a.value;

  const formatter = new Intl.NumberFormat(lng);

  return formatter.format(value);
};

const totalFromStrings = (value: Maybe<string>, quantity: Maybe<string>) => {
  if (!value || !quantity) return 0;

  const parsedQuantity = parseInt(quantity, 10);
  const parsedValue = parseFloat(value);

  return parsedValue * parsedQuantity;
};

const unitMap = {
  [WeightUnit.G]: 'gram',
  [WeightUnit.KG]: 'kilogram',
  [WeightUnit.LB]: 'pound',
  [WeightUnit.OZ]: 'ounce',
};

const defaultFormatOptions: Intl.NumberFormatOptions = {
  maximumFractionDigits: 2,
};

export const formatWeight = (
  locale: string,
  value: number,
  weightUnit?: WeightUnit,
  formatOptions: Partial<Intl.NumberFormatOptions> = {},
): string => {
  if (!weightUnit) {
    return new Intl.NumberFormat(locale, { ...defaultFormatOptions, ...formatOptions }).format(
      value,
    );
  }

  try {
    const unit = unitMap[weightUnit];
    if (!unit) {
      return `${new Intl.NumberFormat(locale, {
        ...defaultFormatOptions,
        ...formatOptions,
      }).format(value)} ${weightUnit}`;
    }

    return new Intl.NumberFormat(locale, {
      ...defaultFormatOptions,
      style: 'unit',
      unit,
      ...formatOptions,
    }).format(value);
  } catch (_) {
    return `${value} ${weightUnit}`;
  }
};

export { formatCurrency, formatNumber, totalFromStrings };
